export class EnumEntry {
    public name: string;
    public value: string;
    public rank?: number;
    public description?: string;
}


// WEBPACK FOOTER //
// ./src/models/EnumEntry.tsx